import React from 'react';
import Header from '../../components/feature/Header';

const Impressum: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">Impressum</h1>
            
            <div className="bg-gray-50 rounded-lg p-8 mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">Angaben gemäß § 5 TMG</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Firmenname</h3>
                  <p className="text-gray-700">Next Step - F.Z.E</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Geschäftsadresse</h3>
                  <div className="text-gray-700 space-y-1">
                    <p>Premises Number Office - C1 - 1F - SF11308</p>
                    <p>Ajman Free Zone C1 Building</p>
                    <p>Ajman Free Zone</p>
                    <p>Vereinigte Arabische Emirate</p>
                    <p>Makani No. 4442612247</p>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Kontakt</h3>
                  <div className="text-gray-700 space-y-2">
                    <div className="flex items-center">
                      <i className="ri-phone-line mr-3 text-red-600"></i>
                      <a href="tel:+971585375437" className="hover:text-red-600 transition-colors">
                        +971 58 537 5437
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-red-600"></i>
                      <a href="mailto:info@nextstep-uae.com" className="hover:text-red-600 transition-colors">
                        info@nextstep-uae.com
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-whatsapp-line mr-3 text-red-600"></i>
                      <button 
                        onClick={() => {
                          const phoneNumber = '+971585375437';
                          const message = encodeURIComponent('Hallo NextStep, ich interessiere mich für die Auswanderungsberatung in die V.A.E. und bitte um weitere Informationen. Mein Name ist: [Name]');
                          window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
                        }}
                        className="hover:text-red-600 transition-colors cursor-pointer"
                      >
                        WhatsApp Chat
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-8 mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">Rechtliche Hinweise</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Haftung für Inhalte</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Haftung für Links</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Urheberrecht</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg p-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">Geschäftstätigkeit</h2>
              
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Unternehmensgegenstand</h3>
                  <p className="text-gray-700 leading-relaxed">
                    NextStep - F.Z.E ist spezialisiert auf Auswanderungsberatung und Unternehmensdienstleistungen für die Vereinigten Arabischen Emirate. Wir bieten umfassende Beratung und Unterstützung bei Firmengründungen, Visa-Angelegenheiten, Kontoeröffnungen und Immobilienberatung.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Zuständige Aufsichtsbehörde</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Ajman Free Zone Authority<br />
                    Vereinigte Arabische Emirate
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Berufsrechtliche Regelungen</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Das Unternehmen unterliegt den Gesetzen und Bestimmungen der Vereinigten Arabischen Emirate sowie den spezifischen Regelungen der Ajman Free Zone.
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center mt-12">
              <p className="text-gray-500 text-sm">
                Stand: November 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;